<template>
  <router-view />
</template>
<script>
export default {
  created() {
    this.$store.dispatch('users/getUserById', { id: this.$route.params.id })
  }
}
</script>
